import React from 'react';

export const WalletAddIcon = () => (
    <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M10.5505 2.09877L10.5255 2.15711L8.10879 7.76544H5.73379C5.16712 7.76544 4.62546 7.88211 4.13379 8.09044L5.59212 4.60711L5.62546 4.52377L5.68379 4.39044C5.70046 4.34044 5.71712 4.29044 5.74212 4.24877C6.83379 1.72377 8.06712 1.14877 10.5505 2.09877Z'
            stroke='#475467'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M15.0417 7.93197C14.6667 7.8153 14.2667 7.7653 13.8667 7.7653H8.1084L10.5251 2.15697L10.5501 2.09863C10.6751 2.1403 10.7917 2.19863 10.9167 2.24863L12.7584 3.02363C13.7834 3.44863 14.5001 3.8903 14.9334 4.42363C15.0167 4.52363 15.0834 4.6153 15.1417 4.72363C15.2167 4.8403 15.2751 4.95697 15.3084 5.08197C15.3417 5.15697 15.3667 5.23197 15.3834 5.29863C15.6084 5.99863 15.4751 6.85697 15.0417 7.93197Z'
            stroke='#475467'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M17.9351 11.8323V13.4573C17.9351 13.624 17.9268 13.7906 17.9184 13.9573C17.7601 16.8656 16.1351 18.3323 13.0518 18.3323H6.55176C6.35176 18.3323 6.15176 18.3156 5.96009 18.2906C3.31009 18.1156 1.89342 16.699 1.71842 14.049C1.69342 13.8573 1.67676 13.6573 1.67676 13.4573V11.8323C1.67676 10.1573 2.69342 8.71563 4.14342 8.09063C4.64342 7.88229 5.17676 7.76562 5.74342 7.76562H13.8768C14.2851 7.76562 14.6851 7.82396 15.0518 7.93229C16.7101 8.44063 17.9351 9.99063 17.9351 11.8323Z'
            stroke='#475467'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M5.59199 4.60645L4.13366 8.08978C2.68366 8.71478 1.66699 10.1564 1.66699 11.8314V9.38978C1.66699 7.02311 3.35033 5.04811 5.59199 4.60645Z'
            stroke='#475467'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
        <path
            d='M17.9322 9.38939V11.8311C17.9322 9.99772 16.7155 8.43939 15.0488 7.93939C15.4822 6.85605 15.6072 6.00605 15.3988 5.29772C15.3822 5.22272 15.3572 5.14772 15.3238 5.08105C16.8738 5.88105 17.9322 7.52272 17.9322 9.38939Z'
            stroke='#475467'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
        />
    </svg>
);
